import { roundForDisplay } from '@app/components/Molecules/Charts/utils/utils'
import { FeatureProperty, LiveLayer } from '../Live.types'
import { appendCacheBuster } from '../Live.utils'

export const formatHoverPropertyValue = (
  value: string | number,
  featureProperty: FeatureProperty,
): string | number => {
  if ((value === null || value === undefined) && featureProperty.if_null)
    return featureProperty.if_null
  if (featureProperty.type === 'timestamp' && value) return new Date(value).toLocaleString()
  if (featureProperty.type === 'image' && value) return appendCacheBuster(String(value))
  if (featureProperty.unit)
    return `${roundForDisplay(value as number, featureProperty.unit)} ${featureProperty.unit}`
  return value
}

export const buildHoverProperties = (
  props: { [name: string]: string | number },
  liveLayer: Pick<LiveLayer, 'feature_properties'>,
): { label: string; value: string | number; type?: string }[] => {
  const orderedProperties = liveLayer.feature_properties
    ? liveLayer.feature_properties.map((featureProperty) => ({
        label: featureProperty.label ?? featureProperty.property,
        value: formatHoverPropertyValue(props[featureProperty.property], featureProperty),
        type: featureProperty.type,
      }))
    : Object.entries(props).map(([label, value]) => ({
        label,
        value,
      }))

  return orderedProperties.filter(
    ({ value }) => value !== null && value !== undefined && value !== '',
  )
}
